"use client";

import { Comments } from "@/components/comments/Comments";
import { type ListingWithCommentsAndReplies } from "@/components/comments/Comments";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

interface CommentsModalProps {
  comments: ListingWithCommentsAndReplies[];
  isLoading?: boolean;
  trigger: React.ReactNode;
  title?: string;
  showListingDetails?: boolean;
}

export function CommentsModal({
  comments,
  isLoading,
  trigger,
  title = "Comments & Replies",
  showListingDetails = true,
}: CommentsModalProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          {comments.map((listing) => (
            <Comments
              key={listing.id}
              listing={listing}
              isLoading={isLoading}
              showListingDetails={showListingDetails}
            />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
